export const verticalScreen = () => {
    let width = window.innerWidth,
    height = window.innerHeight,
    $wrapper = document.getElementById("app"),
    style ="";
    style +="width:" + width +"px;"; // 注意旋转后的宽高切换
    style +="height:" + height +"px;";
    // style +="-webkit-transform: rotate(0); transform: rotate(0);";
    // style +="-webkit-transform-origin: " + width / 2 +"px " + width / 2 +"px;";
    // style +="transform-origin: " + width / 2 +"px " + width / 2 +"px;";
    $wrapper.style.cssText = style;
}